<template>
  <div class="pagina ativa" id="paginaSorteios">
    <div class="pagina-titulo">Sorteios - Loteria Federal</div>
    <div style="background:white;border-radius:10px;padding:25px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:25px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;">
        <div style="font-weight:bold;color:#4a5c2f;font-size:16px;">Resultado Federal</div>
        <button @click="carregarSorteios" style="margin-top:0;padding:8px 18px;font-size:13px;">Atualizar</button>
      </div>
      <div id="resultadoSorteio" style="text-align:center;color:#aaa;">
        <p v-if="resultadoMsg" v-html="resultadoMsg"></p>
        <template v-else-if="sorteioAtual">
          <div style="margin-bottom:15px;"><span style="font-size:13px;color:#888;">Concurso {{ sorteioAtual.concurso }} - {{ sorteioAtual.data }}</span></div>
          <div style="display:flex;gap:10px;justify-content:center;flex-wrap:wrap;margin-bottom:20px;">
            <div v-for="(p, i) in sorteioAtual.premios" :key="i" style="background:#4a5c2f;color:white;border-radius:10px;padding:12px 18px;text-align:center;">
              <div style="font-size:11px;opacity:0.8;">{{ i + 1 }}o</div>
              <div style="font-size:22px;font-weight:bold;">{{ p }}</div>
            </div>
          </div>
        </template>
        <p v-else>Clique em Atualizar.</p>
      </div>
      <div v-if="sorteioAtual" style="margin-top:20px;border-top:1px solid #eee;padding-top:20px;">
        <div style="font-weight:bold;color:#4a5c2f;font-size:14px;margin-bottom:12px;">Numeros por Grupo</div>
        <div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(220px,1fr));gap:12px;">
          <div v-for="g in [5000, 900, 600]" :key="g" style="background:#f5f7f0;border-radius:10px;padding:15px;border:1px solid #d0dbb8;">
            <div style="font-weight:bold;color:#4a5c2f;font-size:13px;margin-bottom:10px;">{{ g.toLocaleString('pt-BR') }} part.</div>
            <div v-for="(p, i) in sorteioAtual.premios" :key="i" style="display:flex;justify-content:space-between;align-items:center;padding:5px 0;border-bottom:1px solid #e8ede0;font-size:12px;">
              <span style="color:#666;">{{ i + 1 }}o ({{ p }})</span>
              <span style="font-weight:bold;color:#4a5c2f;">
                <template v-if="calcularNumeroSorteio(p, g) !== null">
                  {{ calcularNumeroSorteio(p, g) }} <span style="font-size:11px;color:#888;font-weight:normal;">({{ faixa(p, g).min }}-{{ faixa(p, g).max }})</span>
                </template>
                <span v-else style="color:#aaa;">--</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div style="background:white;border-radius:10px;padding:25px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:25px;">
      <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;">
        <div style="font-weight:bold;color:#4a5c2f;font-size:16px;">Datas Programadas</div>
        <button v-if="ehAdmin" @click="abrirModalDataSorteio" style="margin-top:0;padding:8px 18px;font-size:13px;">+ Adicionar</button>
      </div>
      <div id="listaDatassorteio">
        <p v-if="datas.length === 0" style="color:#aaa;text-align:center;">Nenhuma data.</p>
        <div v-else style="overflow-x:auto;">
        <table class="tabela-dash">
          <thead>
            <tr><th>Mes/Ano</th><th>Venc.</th><th>Sorteio</th><th>Assembleia</th><th>Resultado</th><th v-if="ehAdmin">Acoes</th></tr>
          </thead>
          <tbody>
            <tr v-for="x in datas" :key="x.id">
              <td>{{ nomesMes[parseInt(x.mes)] }}/{{ x.ano }}</td>
              <td>Dia {{ x.vencimento }}</td>
              <td style="font-weight:bold;">{{ fmtData(x.dataSorteio) }}</td>
              <td style="color:#3498db;font-weight:bold;">{{ fmtAssembleia(x.dataAssembleia) }}</td>
              <td><button @click="buscarSorteioData(x.dataSorteio, x.vencimento)" style="padding:4px 10px;font-size:12px;margin-top:0;">Buscar</button></td>
              <td v-if="ehAdmin">
                <button @click="editarDataSorteio(x)" style="display:inline-flex;align-items:center;justify-content:center;padding:4px 8px;margin-right:5px;margin-top:0;"><Pencil :size="13" /></button>
                <button @click="deletarDataSorteio(x.id)" style="display:inline-flex;align-items:center;justify-content:center;padding:4px 8px;background:#c0392b;margin-top:0;"><Trash2 :size="13" /></button>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
    </div>

    <div style="background:white;border-radius:10px;padding:25px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:25px;">
      <div style="font-weight:bold;color:#4a5c2f;font-size:15px;margin-bottom:15px;">Filtrar Clientes</div>
      <div style="display:flex;gap:15px;align-items:flex-end;flex-wrap:wrap;">
        <div>
          <label>Dia Vencimento</label>
          <select v-model="filtroDiaVenc" style="width:150px;">
            <option value="">Todos</option>
            <option value="10">Dia 10</option>
            <option value="15">Dia 15</option>
            <option value="20">Dia 20</option>
            <option value="25">Dia 25</option>
          </select>
        </div>
        <button @click="renderizado++" style="margin-top:0;padding:10px 20px;">Filtrar</button>
      </div>
    </div>

    <div style="background:white;border-radius:10px;padding:25px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
      <div style="font-weight:bold;color:#4a5c2f;font-size:15px;margin-bottom:15px;">Clientes do Vencimento</div>
      <div id="tabelaContemplados">
        <p v-if="!vendasSorteio.length" style="color:#aaa;text-align:center;">Busque o sorteio e filtre.</p>
        <p v-else-if="clientesFiltrados.length === 0" style="color:#aaa;text-align:center;">Nenhum cliente.</p>
        <template v-else>
          <div style="margin-bottom:12px;">
            <span style="font-size:13px;color:#666;">Total: <strong>{{ clientesFiltrados.length }}</strong></span>
            <span v-if="totalAptos > 0" style="background:#e8f5e9;color:#27ae60;padding:4px 12px;border-radius:20px;font-size:13px;font-weight:bold;margin-left:8px;">{{ totalAptos }} apto(s)</span>
          </div>
          <div style="overflow-x:auto;">
            <table class="tabela-dash">
              <thead>
                <tr>
                  <th>Cliente</th>
                  <th v-if="ehAdmin">Vendedor</th>
                  <th>Grupo</th><th>Cota</th><th>Part.</th><th>Venc.</th><th>BEM</th><th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="v in clientesOrdenados" :key="v.contrato + '_' + v.cota" :style="{ background: aptosMap[v.contrato + '_' + v.cota] ? '#e8f5e9' : '' }">
                  <td style="padding:8px;" :style="{ fontWeight: aptosMap[v.contrato + '_' + v.cota] ? 'bold' : 'normal' }">{{ v.cliente }}</td>
                  <td v-if="ehAdmin" style="padding:8px;">{{ v.vendedor }}</td>
                  <td style="padding:8px;">{{ v.grupo }}</td>
                  <td style="padding:8px;font-weight:bold;color:#4a5c2f;">{{ v.cota }}</td>
                  <td style="padding:8px;">{{ v.participantes || '--' }}</td>
                  <td style="padding:8px;">Dia {{ v.dataVencimento }}</td>
                  <td style="padding:8px;">{{ v.bem }}</td>
                  <td style="padding:8px;">
                    <span v-if="!sorteioAtual" style="color:#aaa;">Aguardando</span>
                    <template v-else-if="aptosMap[v.contrato + '_' + v.cota]">
                      <span style="background:#27ae60;color:white;padding:3px 10px;border-radius:20px;font-size:12px;font-weight:bold;">APTO</span>
                      <div v-for="(x, i) in aptosMap[v.contrato + '_' + v.cota]" :key="i" style="font-size:11px;color:#1e7e34;">1º SORTEIO - NÚMERO {{ x.n }}</div>
                    </template>
                    <span v-else style="color:#ccc;">--</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </template>
      </div>
    </div>

    <div v-if="modalDataSorteio" class="app-drawer-overlay">
      <div class="app-drawer">
        <h3>Data de Sorteio</h3>
        <label>Mes/Ano</label>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">
          <select v-model="dsForm.mes">
            <option value="01">Jan</option><option value="02">Fev</option><option value="03">Mar</option>
            <option value="04">Abr</option><option value="05">Mai</option><option value="06">Jun</option>
            <option value="07">Jul</option><option value="08">Ago</option><option value="09">Set</option>
            <option value="10">Out</option><option value="11">Nov</option><option value="12">Dez</option>
          </select>
          <select v-model="dsForm.ano">
            <option value="2025">2025</option><option value="2026">2026</option><option value="2027">2027</option>
          </select>
        </div>
        <label style="margin-top:10px;">Vencimento</label>
        <select v-model="dsForm.vencimento">
          <option value="10">Dia 10</option><option value="15">Dia 15</option><option value="20">Dia 20</option><option value="25">Dia 25</option>
        </select>
        <label style="margin-top:10px;">Data do Sorteio</label>
        <input type="date" v-model="dsForm.dataSorteio" />
        <label style="margin-top:10px;">Data da Assembleia <span style="font-weight:normal;color:#888;font-size:11px;">(dd/mm/aaaa)</span></label>
        <input type="text" v-model="dsForm.dataAssembleia" placeholder="Ex: 15/03/2026" maxlength="10" @input="mascaraDataBR" />
        <div class="status erro-msg">{{ statusDataSorteio }}</div>
        <div class="app-drawer-acoes">
          <button @click="fecharModalDataSorteio" style="background:#888;">Cancelar</button>
          <button @click="salvarDataSorteioModal">Salvar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, apiDelete, getSession } from '../api'
import { Pencil, Trash2 } from 'lucide-vue-next'

export default {
  components: { Pencil, Trash2 },
  name: 'PaginaSorteios',
  data() {
    return {
      nomesMes: ['', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      datas: [],
      vendasSorteio: [],
      sorteioAtual: null,
      resultadoMsg: '',
      dataSorteioAtiva: null,
      filtroDiaVenc: '',
      renderizado: 0,
      modalDataSorteio: false,
      idDataSorteioEditando: null,
      dsForm: { mes: '', ano: '', vencimento: '10', dataSorteio: '', dataAssembleia: '' },
      statusDataSorteio: ''
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' },
    clientesFiltrados() {
      const nomeUsuario = getSession().nome
      const fd = this.filtroDiaVenc
      return this.vendasSorteio.filter(v => {
        if (!this.ehAdmin && v.vendedor !== nomeUsuario) return false
        if (fd && v.dataVencimento.toString() !== fd) return false
        return true
      })
    },
    aptosMap() {
      const as = {}
      if (this.sorteioAtual && this.sorteioAtual.premios) {
        this.clientesFiltrados.forEach(v => {
          const cn = parseInt(v.cota.toString().replace(/\D/g, ''))
          if (!cn || !v.participantes) return
          const pr = this.sorteioAtual.premios[0]
          const ns = this.calcularNumeroSorteio(pr, v.participantes)
          if (ns === null) return
          const mg = Math.round(ns * 0.10)
          if (cn >= (ns - mg) && cn <= (ns + mg)) {
            const ch = v.contrato + '_' + v.cota
            if (!as[ch]) as[ch] = []
            as[ch].push({ p: '1o', n: ns, m: mg })
          }
        })
      }
      return as
    },
    totalAptos() { return Object.keys(this.aptosMap).length },
    clientesOrdenados() {
      const ap = this.clientesFiltrados.filter(v => !!this.aptosMap[v.contrato + '_' + v.cota])
      const na = this.clientesFiltrados.filter(v => !this.aptosMap[v.contrato + '_' + v.cota])
      return ap.concat(na)
    }
  },
  created() {
    this.carregarSorteios()
  },
  methods: {
    fmtData(iso) { return iso ? iso.toString().substring(0, 10).split('-').reverse().join('/') : '' },
    fmtAssembleia(v) {
      if (!v) return '—'
      const s = v.toString().trim()
      if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.substring(0, 10).split('-').reverse().join('/')
      return s
    },
    calcularNumeroSorteio(nl, pt) {
      const s = nl.toString().replace(/\D/g, '')
      if (pt === 5000) {
        const u = parseInt(s.slice(-4))
        return u > 5000 ? u - 5000 : u
      }
      for (let o = 0; o < s.length - 2; o++) {
        const i = s.length - 3 - o
        if (i < 0) break
        const j = parseInt(s.substring(i, i + 3))
        if (j <= pt && j > 0) return j
      }
      return null
    },
    faixa(nl, pt) {
      const n = this.calcularNumeroSorteio(nl, pt)
      if (n === null) return { min: null, max: null }
      const m = Math.round(n * 0.10)
      return { min: Math.max(1, n - m), max: n + m }
    },
    async carregarVendasSorteio() {
      const r = await apiGet('vendas/listar')
      if (r.sucesso) {
        const statusExcluidos = ['contemplada', 'cancelada', 'transferida', 'estornada']
        this.vendasSorteio = (r.vendas || [])
          .filter(v => {
            const st = (v.status || '').toLowerCase().trim()
            return (parseInt(v.participante) || 0) > 0 && v.cota && !statusExcluidos.includes(st) && !v.isFilha
          })
          .map(v => ({
            vendedor: v.vendedor,
            cliente: v.cliente,
            contrato: v.contrato,
            grupo: v.grupo,
            cota: v.cota,
            dataVencimento: v.dataVencimento,
            bem: v.bem,
            participantes: v.participante
          }))
      }
    },
    async carregarDatassorteio() {
      const r = await apiGet('sorteio/datas/listar')
      if (r.sucesso) this.datas = r.datas
    },
    async carregarSorteios() {
      await this.carregarDatassorteio()
      if (this.dataSorteioAtiva) {
        await this.buscarSorteioData(this.dataSorteioAtiva.dataSorteio, this.dataSorteioAtiva.vencimento)
        return
      }
      const ultimaProgramada = this.ultimaDataProgramadaPassada()
      if (!ultimaProgramada) {
        this.sorteioAtual = null
        this.resultadoMsg = '<span style="color:#aaa;">Nenhuma das datas programadas abaixo já ocorreu.</span>'
        return
      }
      await this.buscarSorteioData(ultimaProgramada.dataSorteio, ultimaProgramada.vencimento)
    },
    ultimaDataProgramadaPassada() {
      const hoje = new Date().toISOString().substring(0, 10)
      const passadas = this.datas
        .filter(x => x.dataSorteio && x.dataSorteio.toString().substring(0, 10) <= hoje)
        .slice()
        .sort((a, b) => a.dataSorteio.toString().localeCompare(b.dataSorteio.toString()))
      return passadas.length ? passadas[passadas.length - 1] : null
    },
    async buscarSorteioData(ds, vc) {
      const dl = ds.toString().trim().substring(0, 10)
      this.dataSorteioAtiva = { dataSorteio: dl, vencimento: vc }
      this.filtroDiaVenc = vc
      this.resultadoMsg = 'Buscando ' + dl.split('-').reverse().join('/') + '...'
      const r = await apiGet('sorteio/federal/por-data', { data: dl })
      if (!r.sucesso) {
        this.resultadoMsg = '<span style="color:red;">Erro: ' + (r.mensagem || '') + '</span>'
        this.sorteioAtual = null
      } else {
        this.resultadoMsg = ''
        this.sorteioAtual = { concurso: r.concurso, data: r.data, premios: r.premios }
      }
      await this.carregarVendasSorteio()
    },
    abrirModalDataSorteio() {
      this.idDataSorteioEditando = null
      const h = new Date()
      this.dsForm = {
        mes: String(h.getMonth() + 1).padStart(2, '0'),
        ano: String(h.getFullYear()),
        vencimento: '10',
        dataSorteio: '',
        dataAssembleia: ''
      }
      this.statusDataSorteio = ''
      this.modalDataSorteio = true
    },
    fecharModalDataSorteio() { this.modalDataSorteio = false },
    editarDataSorteio(x) {
      this.idDataSorteioEditando = x.id
      this.dsForm = {
        mes: x.mes, ano: x.ano, vencimento: x.vencimento,
        dataSorteio: x.dataSorteio, dataAssembleia: x.dataAssembleia || ''
      }
      this.statusDataSorteio = ''
      this.modalDataSorteio = true
    },
    mascaraDataBR() {
      let v = this.dsForm.dataAssembleia.replace(/\D/g, '')
      if (v.length > 2) v = v.substring(0, 2) + '/' + v.substring(2)
      if (v.length > 5) v = v.substring(0, 5) + '/' + v.substring(5, 9)
      this.dsForm.dataAssembleia = v
    },
    async salvarDataSorteioModal() {
      const id = this.idDataSorteioEditando || ''
      const vc = this.dsForm.vencimento
      const ds = this.dsForm.dataSorteio.toString().substring(0, 10)
      const ms = this.dsForm.mes
      const an = this.dsForm.ano
      const da = (this.dsForm.dataAssembleia || '').trim()
      if (!ds || ds.length < 10) {
        this.statusDataSorteio = 'Informe a data do sorteio.'
        return
      }
      const r = await apiPost('sorteio/datas/salvar', {
        id: id || undefined,
        vencimento: vc,
        dataSorteio: ds,
        mes: ms,
        ano: an,
        dataAssembleia: da || null
      })
      if (r.sucesso) {
        this.fecharModalDataSorteio()
        await this.carregarDatassorteio()
        await this.buscarSorteioData(ds, vc)
      } else {
        this.statusDataSorteio = 'Erro: ' + (r.mensagem || 'falha ao salvar')
      }
    },
    async deletarDataSorteio(id) {
      if (!confirm('Excluir?')) return
      const r = await apiDelete('sorteio/datas/excluir', { id })
      if (r.sucesso) this.carregarDatassorteio()
    }
  }
}
</script>
